import styled from "styled-components";
import { COLORS, THEME } from "../../styles/constants.style";

export const DateTimeChipWrapper = styled.div`
  .MuiChip-root {
    background: ${COLORS.primary_light_blue2};
    border-radius: 4px;
    padding: 8px 0px 8px 8px;
    color: ${COLORS.cirrus_black10};
    font-size: ${THEME.fontSizes[300]};
    font-weight: ${THEME.fontWeights.medium};
    line-height: 16px;
    font-family: ${THEME.fontFamilies.primary};
    .MuiChip-icon {
      color: ${COLORS.cirrus_black};
    }
  }

  .color-black {
    width: 20px;
    height: 20px;
    color: ${COLORS.cirrus_black} !important;
  }
`;
